import styled from 'styled-components';

import LockBadgeIcon from 'components/icons/lock-badge';
import LockUnlockedIcon from 'components/icons/lock-unlocked';

import { AccentBadge } from './accent-badge';
import { IFilledAccentBadgeProps, IStyledIconProps } from './types';

export const FilledAccentBadge = styled(AccentBadge)<IFilledAccentBadgeProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ $textColor }) => $textColor || Styles.color.white};
  background-color: ${({ $fillColor }) => $fillColor || Styles.color.grey.five};
`;

export const StyledLockIcon = styled(LockBadgeIcon)<IStyledIconProps>`
  width: 12px;
  height: 12px;
  margin-right: 3px;
  path {
    fill: ${({ $iconColor }) => $iconColor || Styles.color.white};
  }
`;

export const StyledLockUnlockedIcon = styled(LockUnlockedIcon)<IStyledIconProps>`
  width: 20px;
  height: 20px;
  padding-bottom: 1px;
  path {
    fill: ${({ $iconColor }) => $iconColor || Styles.color.white};
  }
`;
